

import Vue from 'vue'
import VueCookies from 'vue-cookies'
import App from './App'
import router from './router'
import 'lib-flexible/flexible'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'

import './assets/iconfont/iconfont.css'
import $ from 'jquery'
import axios from "axios"
import {get,post,patch,put} from './axios/http.js'
import VideoPlayer from 'vue-video-player'
import Video from 'video.js'
import 'video.js/dist/video-js.css'

Vue.prototype.$video = Video
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer);

Vue.prototype.$get=get;
Vue.prototype.$post=post;
Vue.prototype.$patch=patch;
Vue.prototype.$put=put;
Vue.prototype.baseURL = process.env.API_ROOT;
Vue.prototype.$axios = axios;
Vue.use(AlertPlugin)
Vue.use(ToastPlugin)
Vue.use(VueCookies)
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
/*路由发生改变修改页面的title */
if(to.meta.title) {
document.title = to.meta.title
}
next();
})
/* eslint-disable no-new */
new Vue({
el: '#app',
router,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js